import { useMutation } from '@apollo/client';
import { Button, Tooltip } from 'antd';
import React from 'react';
import { getInventoryUnitApis, hasLibraryScope } from './apiConfig';

const SyncQrCodesButton = ({
  isLibrary = false,
  libraryId,
  selectedInventoryIds = [],
  onSuccess,
  ...buttonProps
}) => {
  const { sync: syncApi } = getInventoryUnitApis(isLibrary);
  const [syncQrCodes, { loading }] = useMutation(syncApi?.document, {
    onError() {},
  });

  const selectedCount = selectedInventoryIds?.length || 0;

  const handleSync = async () => {
    const response = await syncQrCodes({
      variables: syncApi?.getVariables({
        libraryId,
        libraryInventoryIds: selectedCount ? selectedInventoryIds : null,
      }),
    });
    if (response?.data?.[syncApi?.key] && onSuccess) {
      onSuccess();
    }
  };

  const tooltipTitle = selectedCount
    ? `Sync units and QR codes for the ${selectedCount} selected ${
        selectedCount === 1 ? 'toy' : 'toys'
      } only. Clear the selection to sync the whole library.`
    : 'Sync units and QR codes for all toys in this library. To sync specific toys, select their rows first.';

  return (
    <Tooltip title={tooltipTitle} placement="bottom">
      <Button
        {...buttonProps}
        loading={loading}
        disabled={!hasLibraryScope(isLibrary, libraryId)}
        onClick={handleSync}
      >
        {selectedCount ? `Sync Units (${selectedCount})` : 'Sync Units'}
      </Button>
    </Tooltip>
  );
};

export default SyncQrCodesButton;
